// store/modules/ui.js
//
// Small cross-cutting UI-preference flags that many unrelated components need to read
// reactively (not just a parent/child chain), so plain localStorage (as used by the
// language/front-version toggles) isn't enough on its own.
const STORAGE_KEY = 'accessibilityMode'

export default {
    namespaced: true,
    state: {
        // Shows a visible/discoverable scrollbar wherever content scrolls but its
        // scrollbar is normally hidden (see .visible-scrollbar / .hide-scrollbar in
        // assets/scss/utils/styleDefault.scss). Off by default to keep the existing look.
        accessibilityMode: localStorage.getItem(STORAGE_KEY) === 'true',
    },
    mutations: {
        setAccessibilityMode(state, value) {
            state.accessibilityMode = value
            localStorage.setItem(STORAGE_KEY, value)
        },
    },
    getters: {
        accessibilityMode: (state) => state.accessibilityMode,
    },
}
